import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import Button from "components/button";
import AtriumLogo from "layouts/auth/AtriumLogo";
import { ErrorContext } from "./error-boundary";

const InternalError = ({ showLogo = false }) => {
  const { resetError } = useContext(ErrorContext);
  const navigate = useNavigate();

  const returnToDashboard = () => {
    resetError && resetError();
    navigate("/admin/dashboard");
  };

  return (
    <div className="mx-auto flex w-full max-w-xl flex-1 flex-col items-center justify-center gap-3 px-4 py-16 text-center">
      {showLogo && <AtriumLogo className="mb-6" />}
      <p className="text-display">500</p>
      <h1 className="text-title">Something Went Wrong</h1>
      <p className="text-sm text-fg-muted">
        We’re experiencing a temporary issue on our end. Please try again, or
        contact support if the problem persists.
      </p>
      <div className="mt-3 flex flex-wrap justify-center gap-2">
        <Button variant="secondary" onClick={resetError}>
          Try Again
        </Button>
        <Button onClick={returnToDashboard}>Return to Dashboard</Button>
      </div>
    </div>
  );
};

export default InternalError;
